import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


const vUI_ExchangeRateType_Search_Fields: {[id: string]: ISearchProviderField} = {
    WB_EXCHANGERATEM_ID:    {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Wb Exchange Rate Type Id',     columnResourceName: 'colId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    EXCHANGE_RATE_TYPE_ID:       {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Exchange Rate Type ID',        columnResourceName: 'colExchangeRateTypeId',             alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    EXCHANGE_RATE_TYPE_NAME:     {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Exchange Rate Type Name',      columnResourceName: 'colExchangeRateTypeName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CURRENCY_ID:     {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Reference Currency',      columnResourceName: 'colCurrencyRef',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    BUY_RATE:     {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Buy Rate Type',      columnResourceName: 'colBuyRate',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    SELL_RATE:     {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Sell Rate Type',      columnResourceName: 'colSellRate',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    SOURCE_NAME:  {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Source',      columnResourceName: 'colsourceName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    SOURCE_ID:  {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Source ID',      columnResourceName: 'colsourceId',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

const SimulationInputSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_EXCHANGERATEM_ID',
        id_ui: 'EXCHANGE_RATE_TYPE_ID',
        name:  'EXCHANGE_RATE_TYPE_NAME'

    },

    searchProviderFields: vUI_ExchangeRateType_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_ExchangeRateType_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const ExchangeRateTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "ExchangeRateTypeSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Source', searchProviderFieldId: 'SOURCE_NAME', renderOptions: {}},
        {profileFilterName: 'Ex. Rate Type ID', searchProviderFieldId: 'EXCHANGE_RATE_TYPE_ID', renderOptions: {}},
        {profileFilterName: 'Ex. Rate Type Name', searchProviderFieldId: 'EXCHANGE_RATE_TYPE_NAME', renderOptions: {}},
        {profileFilterName: 'Reference Currency', searchProviderFieldId: 'CURRENCY_ID', renderOptions: {}},

    ], //ISearchFields
    profileDisplayFields: [
        'SOURCE_NAME','EXCHANGE_RATE_TYPE_ID','EXCHANGE_RATE_TYPE_NAME', 'CURRENCY_ID','BUY_RATE', 'SELL_RATE',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: SimulationInputSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ExchangeRateTypeSearch: ISearch = {
    searchName: "Find Exchange Rate Type",
    renderOptions: {ui5ResourceId: "ExchangeRateTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ExchangeRateTypeSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("ExchangeRateBO", "ExchangeRateType", ExchangeRateTypeSearch, "ExchangeRateType Search")

export {ExchangeRateTypeSearch}